import { useEffect } from 'react';
import { useFormikContext } from 'formik';

import CloseBrowserTabDetector from '../../services/common/closeBrowserTabDetector';

const CloseTabItemFormDetector = () => {
  const { dirty } = useFormikContext();

  useEffect(() => {
    const closeBrowserTabDetector = new CloseBrowserTabDetector({});
    if (dirty) {
      closeBrowserTabDetector.init();
    }

    return () => {
      if (dirty) {
        closeBrowserTabDetector.destroy();
      }
    };
  }, [dirty]);

  return null;
};

export default CloseTabItemFormDetector;
